export const sanitizePayload = (payload) => {
  let res = {};
  Object.entries(payload).map(([key, value]) => {
    if (value === undefined || value === null) return;
    // if (Array.isArray(value) && value.length === 0) return;

    if (['addressLine', 'city', 'state', 'country', 'pincode'].includes(key)) {
      if (!res.address) res.address = {};
      res.address[key] = value;
    } else {
      res[key] = value;
    }
  });
  return res;
};

export const initializeFormData = (formTemplate) => {
  if (!formTemplate) return;

  let updatedFormData = {};
  formTemplate.map((formField) => {
    if (formField.type === 'MultiSelect') updatedFormData[formField.slug] = [];
    else if (formField.type === 'Boolean')
      updatedFormData[formField.slug] = false;
    else updatedFormData[formField.slug] = null;
  });
  return updatedFormData;
};
